/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { ProductApprovalCheckStepDto } from './ProductApprovalCheckStepDto';
export type ProductApprovalCertificateCheckStepDto = (ProductApprovalCheckStepDto & {
    state?: ProductApprovalCertificateCheckStepDto.state;
    certificateCreatedOn?: string;
    approvalDate?: string;
});
export namespace ProductApprovalCertificateCheckStepDto {
    export enum state {
        OPEN = 'OPEN',
        NOT_AVAILABLE = 'NOT_AVAILABLE',
        AVAILABLE = 'AVAILABLE',
    }
}

